import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function CourierBookingApi() {
  const faqs = [
    {
      question: "What is Mokshiq Courier & Logistics Booking API?",
      answer: "Mokshiq Courier Booking API (by Rakle Service Private Limited) aggregates Delhivery, BlueDart, DTDC, Xpressbees, and Shadowfax into a single API for pincode serviceability, rate calculation, shipping label printing, and tracking."
    },
    {
      question: "Can retailers print shipping labels directly?",
      answer: "Yes, our API generates PDF shipping manifests and AWB labels ready for thermal printing."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-truck-fast me-2"></i>Logistics &amp; Courier API
            </span>
            <h1 className="page_title text-white mb-3">Courier Booking &amp; Tracking API</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Multi-courier aggregator API for shipment booking, AWB printing, and real-time tracking powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">API Solutions</a></li>
              <li className="active"><a href="#!">Courier Booking API</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-map-location-dot text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Pincode Serviceability</h3>
                  <p className="text-muted small">Check pickup and delivery serviceability across 29,000+ Indian pincodes.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-barcode text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Instant AWB &amp; Label</h3>
                  <p className="text-muted small">Instant Air Waybill (AWB) number assignment and downloadable shipping label PDFs.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-truck-ramp-box text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Real-Time Tracking</h3>
                  <p className="text-muted small">Live tracking webhooks for out-for-delivery, in-transit, and delivered shipment statuses.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="Courier Booking FAQs" subtitle="Frequently asked questions about logistics and courier API integration." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default CourierBookingApi;
